<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <edit-icon
      v-b-tooltip.hover.html="edit_title"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'Company_admin_DIDs_edit', params: { id: params.data.did } })"
    />
    <trash-2-icon
      v-b-tooltip.hover.html="delete_title"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="ConfirmDelete"
    />
  </div>
</template>

<script>
  import {  EditIcon, Trash2Icon } from 'vue-feather-icons'
    export default {
        name: "CellRendererActions",
      components: {

        EditIcon,
        Trash2Icon
      },
      data:() =>({
        delete_title: {title: 'Delete'},
        edit_title: {title: 'Edit'},
      }),
      methods:{
        ConfirmDelete () {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Are you sure?',
            text: 'You will not be able to recover this User!',
            accept: this.Delete,
            acceptText: 'Delete'
          })
        },
        Delete () {
          this.$store.dispatch("didcompany/Delete", this.params.data.did)
            .then(() => {
              this.params.data.refreshData()
              this.ShowSuccessMessage({
                title: 'User Deleted',
                text: 'The selected User was successfully deleted'
              })
            })
            .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        },

        // Notify
        ShowSuccessMessage ({ title, text }) {
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            title,
            text
          })
        },
        ShowErrorMessage ({ title, text }) {
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title,
            text
          })
        }
      }
    }
</script>

<style scoped>

</style>
